import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Silver Plan',
  price: '£99',
  ebooks: 'Up to 200 ebooks',
  period: 'Annual subscription',
  image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&q=80&w=800',
  features: ['Access to 200 curated titles', 'Read on any device', 'Offline reading mode', 'Standard support'],
  stripeLink: 'https://buy.stripe.com/4gM00jbrv27CgQM7Y86kg00',
  popular: false,
  borderColor: 'border-slate-200'
}, {
  name: 'Gold Plan',
  price: '£120',
  ebooks: 'Up to 700 ebooks',
  period: 'Annual subscription',
  image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&q=80&w=800',
  features: ['Access to 700 curated titles', 'Read on any device', 'Offline reading mode', 'Priority email support', 'Early access to new releases'],
  stripeLink: 'https://buy.stripe.com/28E3cvdzD9A4fMI92c6kg01',
  popular: true,
  borderColor: 'border-accent'
}, {
  name: 'Platinum Plan',
  price: '£150',
  ebooks: 'Unlimited ebooks',
  period: 'Annual subscription',
  image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&q=80&w=800',
  features: ['Unlimited access to full library', 'Read on any device', 'Offline reading mode', '24/7 Premium support', 'Early access to new releases', 'Family sharing (up to 3 users)'],
  stripeLink: 'https://buy.stripe.com/28E28r537fYs6c80vG6kg02',
  popular: false,
  borderColor: 'border-slate-200'
}];
export function PricingCards() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-96">
      {plans.map((plan, index) => <motion.div key={plan.name} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.15,
      duration: 0.5
    }} className={`flex flex-col bg-white rounded-xl shadow-sm border ${plan.borderColor} overflow-hidden relative group hover:shadow-lg transition-all duration-300`} data-id="element-97">
          {plan.popular && <div className="absolute top-4 right-4 z-10 bg-accent text-white px-3 py-1 rounded-full text-sm font-semibold shadow-sm" data-id="element-98">
              Most Popular
            </div>}

          {/* Card Image */}
          <div className="h-48 overflow-hidden relative" data-id="element-99">
            <img src={plan.image} alt={`${plan.name} visual`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-100" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" data-id="element-101" />
            <div className="absolute bottom-4 left-4 text-white font-bold text-lg drop-shadow-md" data-id="element-102">
              {plan.ebooks}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-8 flex-1 flex flex-col" data-id="element-103">
            <h3 className="text-2xl font-bold text-slate-dark mb-2" data-id="element-104">
              {plan.name}
            </h3>
            <div className="flex items-baseline gap-2 mb-1" data-id="element-105">
              <span className="text-4xl font-bold text-primary" data-id="element-106">
                {plan.price}
              </span>
              <span className="text-slate-500 text-sm" data-id="element-107">/ year</span>
            </div>
            <p className="text-sm text-slate-500 mb-6 font-medium bg-slate-50 inline-block py-1 px-2 rounded self-start" data-id="element-108">
              {plan.period}
            </p>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-109">
              {plan.features.map(feature => <li key={feature} className="flex items-start gap-3 text-slate-600" data-id="element-110">
                  <Check className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-111" />
                  <span className="text-sm" data-id="element-112">{feature}</span>
                </li>)}
            </ul>

            <a href={plan.stripeLink} className={`w-full block text-center py-4 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg active:transform active:scale-95 ${plan.popular ? 'bg-accent hover:bg-accent-dark text-white' : 'bg-slate-800 hover:bg-slate-700 text-white'}`} data-id="element-113">
              Buy Now
            </a>
          </div>
        </motion.div>)}
    </div>;
}